import React from 'react';
import { useTranslation } from '../hooks/useTranslation';
import { ICONS } from '../constants';

export type BiddingRevisionBannerKind = 'pending' | 'approved' | 'rejected' | null;

interface BiddingRevisionBannerProps {
  kind: BiddingRevisionBannerKind;
  onDismiss?: () => void;
}

const BiddingRevisionBanner: React.FC<BiddingRevisionBannerProps> = ({ kind, onDismiss }) => {
  const { t } = useTranslation();
  if (!kind) return null;

  const styles =
    kind === 'pending'
      ? 'bg-yellow-500/15 border-yellow-500/50 text-yellow-200'
      : kind === 'approved'
        ? 'bg-green-500/15 border-green-500/50 text-green-200'
        : 'bg-red-500/15 border-red-500/50 text-red-200';

  const message =
    kind === 'pending'
      ? t('biddingRevision.bannerPending')
      : kind === 'approved'
        ? t('biddingRevision.bannerApproved')
        : t('biddingRevision.bannerRejected');

  return (
    <div className={`w-full border-b px-4 py-2.5 flex items-center gap-3 ${styles}`}>
      <ICONS.AlertTriangle className="w-4 h-4 flex-shrink-0" />
      <p className="text-sm flex-1">{message}</p>
      {onDismiss && kind !== 'pending' && (
        <button
          type="button"
          onClick={onDismiss}
          className="text-xs underline opacity-80 hover:opacity-100"
        >
          {t('biddingRevision.dismiss')}
        </button>
      )}
    </div>
  );
};

export default BiddingRevisionBanner;
